<template>
    <div id="pass-sanitaire" class="popin-modal centered" v-show="isPopinDisplayed" v-observe-visibility="{ callback: popin_passSanitaireDisplayed_callback }">
        <div class="popin-container">
            <div class="popin-closure" v-on:click="popin_passSanitaireClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin-closure-responsive" v-on:click="popin_passSanitaireClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin">
                <div class="popin-content">
                    <div class="popin-content-container">
                        <p>&nbsp;</p>
                        <img src="/public/assets/images/Pass_Sanitaire_2.jpg" />
                        <p>&nbsp;</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import anime from 'animejs/lib/anime.es';

export default {
    name: "Pass_Sanitaire",
    components: {},
    data: () => ({
        // popin parameters
        isPopinDisplayed: false
    }),
    methods: {
        popin_passSanitaireDisplayed: function() {
            this.isPopinDisplayed = true;
        },
        popin_passSanitaireClosed: function() {
            this.$store.dispatch('passSanitaire/setData');

            var self = this;
            anime({
                targets: 'div#pass-sanitaire.popin-modal > div.popin-container',
                opacity: [1, 0],
                duration: 250,
                easing: 'linear',
                complete: function(anime) {
                    self.isPopinDisplayed = false;
                }
            });
        },
        popin_passSanitaireDisplayed_callback(visible, entry) {
            if (!visible) {
                return;
            }

            var self = this;
            anime({
                targets: 'div#pass-sanitaire.popin-modal > div.popin-container',
                opacity: [0, 1],
                duration: 250,
                easing: 'linear'
            });
        }
    }
}
</script>